import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { TableListRequest } from "../models/table-list-request.interface";
import { Observable } from "rxjs";
import { RequiresPermissions } from "../decorators/evealuate-permission.decorator";
import { PermissionConstants } from "../constants/permission-constants";

const equipmentMasterEndPoint = "v1/equipments";
const serviceMasterEndPoint = "v1/services";
const vehicleTypeMasterEndPoint = 'v1/vehicle-types';
const warehouseMasterEndPoint = 'v1/warehouses';
const reservationMasterEndPoint = 'v1/warehouse-reservations';



@Injectable({
  providedIn: "root"  // Ensures the service is available app-wide
})
export class MasterService {

    private baseUrl: string = environment.apiBaseUrl;

    constructor(private http: HttpClient) {
    }

    getEquipmentStats(): Observable<any> {
        return this.http.get(`${this.baseUrl}/${equipmentMasterEndPoint}/stats`);
    }

    getEquipmentList(listRequest: TableListRequest): Observable<any> {
        return this.http.post(
            `${this.baseUrl}/${equipmentMasterEndPoint}/list`,
            listRequest
        );
    }

    setEquipmentStatus(shouldSetActive: boolean, idList: string[]) {
        return this.http.patch(
            `${this.baseUrl}/${equipmentMasterEndPoint}/status?status=${shouldSetActive}`,
            idList
        );
    }

    getEquipment(id: string) {
        return this.http.get(
            `${this.baseUrl}/${equipmentMasterEndPoint}/${id}`
        );
    }

    addEquipment(equipment: any) {
        return this.http.post(
            `${this.baseUrl}/${equipmentMasterEndPoint}`,
            equipment
        );
    }

    updateEquipmentMaster(id: string, equipment: any) {
        return this.http.put(
            `${this.baseUrl}/${equipmentMasterEndPoint}/${id}`,
            equipment
        );
    }

    getReservationStats(): Observable<any> {
        return this.http.get(`${this.baseUrl}/${reservationMasterEndPoint}/stats`);
    }

    getReservationList(listRequest: TableListRequest): Observable<any> {
        return this.http.post(
            `${this.baseUrl}/${reservationMasterEndPoint}/list`,
            listRequest
        );
    }

    setReservationStatus(shouldSetActive: boolean, idList: string[]) {
        return this.http.patch(
            `${this.baseUrl}/${reservationMasterEndPoint}/status?status=${shouldSetActive}`,
            idList
        );
    }

    getReservation(id: string) {
        return this.http.get(
            `${this.baseUrl}/${reservationMasterEndPoint}/${id}`
        );
    }

    addReservation(warehouse: any) {
        return this.http.post(
            `${this.baseUrl}/${reservationMasterEndPoint}`,
            warehouse
        );
    }

    updateReservationMaster(id: string, warehouse: any) {
        return this.http.put(
            `${this.baseUrl}/${reservationMasterEndPoint}/${id}`,
            warehouse
        );
    }

    getWarehouseStats(): Observable<any> {
        return this.http.get(`${this.baseUrl}/${warehouseMasterEndPoint}/stats`);
    }

    getWarehouseList(listRequest: TableListRequest): Observable<any> {
        return this.http.post(
            `${this.baseUrl}/${warehouseMasterEndPoint}/list`,
            listRequest
        );
    }

    setWarehouseStatus(shouldSetActive: boolean, idList: string[]) {
        return this.http.patch(
            `${this.baseUrl}/${warehouseMasterEndPoint}/status?status=${shouldSetActive}`,
            idList
        );
    }

    getWarehouse(id: string) {
        return this.http.get(
            `${this.baseUrl}/${warehouseMasterEndPoint}/${id}`
        );
    }

    addWarehouse(warehouse: any) {
        return this.http.post(
            `${this.baseUrl}/${warehouseMasterEndPoint}`,
            warehouse
        );
    }

    updateWarehouseMaster(id: string, warehouse: any) {
        return this.http.put(
            `${this.baseUrl}/${warehouseMasterEndPoint}/${id}`,
            warehouse
        );
    }

    getVehicleStats(): Observable<any> {
        return this.http.get(
          `${this.baseUrl}/${vehicleTypeMasterEndPoint}/stats`
        );
    }

    @RequiresPermissions({ permissionIds: [PermissionConstants.MASTERS.VEHICLETYPE_MASTER.LIST] })    
    getVehicleList(listRequest: TableListRequest): Observable<any> {
        return this.http.post(
          `${this.baseUrl}/${vehicleTypeMasterEndPoint}/list`,
          listRequest
        );
    }

    setVehicleStatus(shouldSetActive: boolean, idList: string[]) {
        return this.http.patch(
          `${this.baseUrl}/${vehicleTypeMasterEndPoint}/status?status=${shouldSetActive}`,
          idList
        );
    }

    getVehicle(id: string) {
        return this.http.get(
          `${this.baseUrl}/${vehicleTypeMasterEndPoint}/${id}`
        );
    }

    addVehicle(equipment: any) {
        return this.http.post(
          `${this.baseUrl}/${vehicleTypeMasterEndPoint}`,
          equipment
        );
    }

    updateVehicleMaster(id: string, equipment: any) {
        return this.http.put(
            `${this.baseUrl}/${vehicleTypeMasterEndPoint}/${id}`,
            equipment
        );
    }

    listVendorsByService(serviceId: string, onlyActive: boolean) {
        return this.http.get(
            `${this.baseUrl}/${serviceMasterEndPoint}/${serviceId}/vendors?activeOnly=${onlyActive}`
        );
    }

    listEquipmentsByService(serviceId: string, onlyActive: boolean) {
        return this.http.get(
            `${this.baseUrl}/${serviceMasterEndPoint}/${serviceId}/equipments?activeOnly=${onlyActive}`
        );
    }

    getServiceById(id: string) {
        return this.http.get(
          `${this.baseUrl}/${serviceMasterEndPoint}/${id}`
        );
      }
}
